export default {
    // Sidebar
    'Nova OS Proativa': "Nueva OT proactiva ",
    'Interno': "Interno",
    'Externo': "Externo",
    'Preventiva': "Preventiva",
    'Preventiva Programada':  "Preventiva Programada",
    "Preventiva Programada Armazém": "Preventiva Programada Almacén",
    'Reaberta': "Reabierto",
    'Execuções': "Ejecuciones",
    'Armazém': "DEPOSITO",
    'Frota': "Flota",
    'Sair': "Salir",
    'Inventário':  "Inventário",

    // Nova Os
    'Voltar': "Volver",
    'Nova OS': "Nueva OT",
    'Operação': "Operación",
    'Placa': "Placa",
    'Segmento': "Segmento",
    'Problemas': "Problemas",
    'Descrição do Problema': "Descripción del problema",
    'Gerar OS': "Generar OT",
    'Cancelar': "Cancelar",

    // OS Interna
    "Nenhum resultado encontrado": "Ningún resultado encontrado",
    "Exibindo resultado": "Mostrando resultado",
    "de": "en",
    "Aberta há": "Abierta hace",
    "Concluída em": "Concluída en",
    "Falha ao carregar os dados da OS": "Error al cargar los datos de la OT",
    "Falha ao carregar os itens da OS": "Error al cargar los elementos de la OT",

    // Ordem Servico
    "Detalhes": "Detalles",
    "Mostrar": "Mostrar",
    "Esconder": "Ocultar",
    "Telefone": "Teléfono",
    "Data": "Fecha",
    "Início": "Inicio",
    "Final": "Final",
    "Fornecedor": "Proveedor",
    "Tipo": "Tipo",
    "Ciclo preventiva": "Ciclo preventivo",
    "Criticidade": "Criticidad",
    "Previsão de Atendimento": "Previsión de Atención",
    "Atendimento do Item": "Atención del Ítem",
    "Observações": "Observaciones",
    "Imagens": "Imágenes",
    "Salvar": "Guardar",
    "Ordens de Serviço": "Órdenes de trabajo",
    
    // OS Item
    "Iniciar": "Iniciar",
    "Ações": "Acciones",
    "Continuar": "Continuar",
    "Pausar": "Pausar",
    "Registrar Peças": "Registrar Piezas",
    "Cancelar OS": "Cancelar OT",
    "OS Externa": "OT Externa",
    "Insira um serviço. Tente novamente.": "Ingrese un servicio. Inténtalo de nuevo.",

    // Modal Itens
    "Serviços": "Asistencia",
    "Observação": "Observación",
    "Anexo de arquivos": "Adjunto de archivos",
    "Informe o valor total dos serviços/peças": "Informe el valor total de los servicios/piezas",
    "Informe o motivo do socorro em rota": "Informe el motivo de la asistencia en ruta",
    "Informe o pneu utilizado neste serviço": "Informe el neumático utilizado en este servicio",
    "Foi trocado o pneu": "Se cambió el neumático",
    "Finalizar OS": "Finalizar OS",

    // Modal se foi utilizado peças
    "Foi utilizado Peças?": "¿Se utilizaron Piezas?",
    "Se foi utilizado peças neste atendimento, pressione 'Sim' na opção abaixo!": "Si se utilizaron piezas en esta atención, ¡presiona 'Sí' en la opción de abajo!",
    "Não": "No",
    "Sim": "Sí",

    // Modal Itens Fim
    "Informe os itens utilizados neste serviço": "Informe los elementos utilizados en este servicio",
    "Fechar": "Cerrar",
    "Peças": "Piezas",
    "Peça": "Pieza",
    "Quantidade": "Cantidad",
    "Preço": "Precio",
    "Informe o pneu novo": "Informe el neumático nuevo",

    // Modal Pause
    "Informe a Justificativa": "Informe la Justificativa",
    "Confirmar Pausa": "Confirmar Pausa",
    "Justificativa": 'Justificativa',
    "ir ao banheiro": 'ir al baño',
    "Fim de expediente": 'Fin del negocio',
    "Atendimento": 'Servicio',
    "Refeição": 'Almuerzo',
    "Aguardando Peças": 'Esperando piezas',
    "Auxílio externo": 'Asistencia externa',
    'Selecione qual peça está aguardando': 'Seleccione qué repuesto está esperando',

    // Confirmar OS Externa
    "Confirmar OS Externa": "Confirmar Orden de Servicio Externa",
    "Deseja realmente enviar OS": "¿REALMENTE QUIERES ENVIAR LA OT",
    "Confirmar": "Confirmar",

    // Lista de execução
    "Lista de execução": "Lista de ejecución",
    "Nenhuma execução ativa": "Ninguna ejecución activa",
    "Início Atendimento": "Inicio Atención",
    "Encerrar OS": "Cerrar OT",
    "Acessar OS": "Acceder OS",
    "Colaborador": "Colaborador",
    "Execuções em Pause": "Ejecuciones en Pausa",
    "Nenhuma execução em pause": "Ninguna ejecución en pausa",

    // Login
    "Torne sua rotina mais dinâmica": "Haz tu rutina más dinámica",
    "ACESSO AO SISTEMA": "ACCESO AL SISTEMA",
    "Terminal Oficina": "Terminal del Taller",
    "Realize o login e tenha acesso ao controle": "Inicia sesión y accede al control",
    "e gestão de suas Ordens de Serviço": "y gestión de tus Órdenes de Trabajo",
    "Mecânico Externo": "Mecánico Externo",
    "Acessar": "Acceder",
    "Falha ao fazer login": "Fallo al iniciar sesión",

    // Filtros Internas
    "Ordenar": "Ordenar",
    "Antigas Primeiro": "Antiguas Primero",
    "Recentes Primeiro": "Recientes Primero",
    "Maior": "Mayor",
    "Menor": "Menor",
    "Segmentos": "Segmentos",
    "Período": "Período",
    "Execução": "Ejecución",
    "Todos": "Todos",
    "Pendentes": "Pendientes",
    "Pendente": "Pendiente",
    "Finalizadas": "Finalizadas",
    "Aplicar filtro": "Aplicar filtro",
    "Limpar filtros": "Limpiar filtros",
    "Esconder filtros": "Ocultar filtros",
    "Criado por": "Creado por",
    "Usuário": "Usuario",
    "Ação": "Acción",

    // Os Preventivas
    "Filtre as OS Preventivas": "Filtre las OT Preventivas",
    "Preventivas Vencidas": "Preventivos Vencidos",
    "Preventivas à Vencer": "Preventivos que están por vencer",
    "Carrocerias Vencidas": "Preventivos de caja vencidos",
    "Atualizar": "Actualizar",

    // Modais Preventivas
    "ACAO": "ACCIÓN",
    "PLACA": "PLACA",
    "PROXIMO_CICLO": "PRÓXIMO CICLO",
    "VENCIMENTO": "VENCIMIENTO",
    "PROXIMO_KM": "PRÓXIMO KM",
    "KM_ATUAL": "KM ACTUAL",
    "Vincular Fornecedor": "Vincular Proveedor",

    // Inventário
    "Não contados": "Sin contar",
    "Contados": "Contados",
    "Ordenação": "Ordenación",
    "Total Itens": "Articulos totales",
    "Status": "Estado",
    "Inventário criado com sucesso!": "¡Inventario creado con éxito!",
    "Já existe um inventário em execução": "Ya existe un inventario en ejecución",
    "Deseja iniciar um novo inventário?": "¿Desea iniciar un nuevo inventario?",
    "Inventário de Estoque": "Inventario de Stock",

    // Modal atendimento

    "Informe os três primeiros dígitos do seu CPF para confirmar sua identidade": "CONFIRME SU IDENTIDAD CON SUS 3 PRIMEROS NUMEROS DE SU REGISTRO",
    'Confirmar identidade': "Confirmar Identidad",

    "Erro do Motorista": "Error del controlador",
    "Defeito não Encontrado": "Defecto no encontrado",

    "Informe o serviço": "Informar al servicio",
    "Insira os Itens": "INSERTAR LOS ELEMENTOS: REGISTRAR LAS PIEZAS",

    "Alterar Fornecedor": "Cambiar proveedor",
    "Preventivas Armazém": "Preventivos Deposito",
    "Outros": "Otros",
    "Ver Encerradas": "VISUALIZAR LISTA DE LAS ULTIMAS OT CERRADAS",
    "Tem dúvida?": "Tienes Dudas?",
    "Nenhuma OS aguardando aprovação": "No hay ningún sistema operativo pendiente de aprobación",
    "Aguardando Aprovação": "en espera de aprobación",


    "OS Preventivas Vencidas": "OT Preventivos vencidos",

    "OS Encerradas - Últimas 15 OS": "OT CERRADAS- ULTIMAS 15 OT",
    "DATA": "FECHA",

    'Precisa de Ajuda?': '¿Necesitas Ayuda?',
    'Desejamos um ótimo 2024!': 'Desejamos un próspero 2024',

    'Bem vindo(a) ao Terminal da Borracharia!': 'Bienvenidos a la Gomeria!',
    'Realize a gestão de pneus pelo novo terminal da borracharia!': '¡Administre neumáticos usando la nueva terminal de tienda de neumáticos!',
    'Aderência Aferição 01': 'ADHERENCIA DE CALIBRACIÓN DE',
    'Aderência Aferição 02': 'ADHERENCIA DE MEDICIÓN DE',
    'de Calibragem': 'CALIBRACIÓN',
    'Aferição': 'Exploración',
    'Movimentação/Troca': 'Movimiento/Intercambio',
    'Descarte': 'Desecho',
    'Serviço': 'Servicio',
    'Borracharia': 'Tienda de Neumáticos',
    'Placas': 'Patente / Placa',
    'Inverter pneus': 'Invertir neumáticos',

    'AÇÃO': 'ACCIÓN',
    'TIPO': 'TIPO',
    'CONJUNTO': 'COLOCAR',
    'AFERIÇÃO': 'MEDICIÓN',

    'Selecione um Pneu': 'Seleccione un neumático',
    'Informar KM': 'Reportar kilómetros',
    'Informar Aferição': 'Informe de Medición',
    'Aferindo NR Informar Calibragem': 'Medición NR Fuego',
    'Última Aferição': 'Última Medición',
    'Novas Aferições': 'Nuevas Medición',
    'Última aferição NR fogo': 'Última medición nº fuego',
    'Registrar Aferições': 'Registrar Medidas',
    'Realizar avaliação': 'Realizar evaluación',
    'Preditiva': 'Predictivas',
    'Externas Armazém': 'Deposito Externo',
    'Carrocerias à Vencer': 'Preventivos de la Caja',

    'Problema': 'Problema',
    'Descartes': 'Descartes',

    'OS Preditiva': 'OT PREDICTIVA',

    "Fora do Prazo": "Fuera de plazo",
    "Dentro do Prazo": "Dentro del plazo",
    
    'Gerar OS Preditiva': 'GENERAR OT PREDICTIVA',
    'Iniciar novo inventário': 'Iniciar un nuevo inventario',
    'Dt Inicial': 'Fecha inicial',
    'Dt Final': 'Fecha final',
    
    "CALIBRAGEM": "CALIBRACIÓN",
    "Nunca feito": "Nunca Realizado",
    "FOGO": "FUEGO",
    "Informar Calibragem": "Informe de Calibración",
    "Comece a digitar o nome do fornecedor para exibir na lista abaixo": "Comience a escribir el nombre del proveedor que desea mostrar en la lista a continuación.",

    "Portugues": "Portugués",
    "Mercosul": "Mercosur",
    "Ingles": "Inglés",
    'Frances': "Francés",
    'Alemao': 'Alemán',
    'Holandes': 'Holandés',
    'Espanhol': 'Español',
    
    "O ESFORÇO DE HOJE É O SUCESSO DE AMANHA": "EL ESFUERZO DE HOY ES EL ÉXITO DE MAÑANA",

    "CODIGO OS": "CÓDIGO OT",
    "TODOS": "TODOS",
    "Socorro em Rota pendente de atendimento": "Asistencia en ruta pendiente de atención",
    "FILTROS": "FILTROS",
    "Salvar Filtro": "Guardar filtro",
    "Motorista": "Conductor",
    "Orçamento": "Presupuesto",
    "Confirmar Orçamento": "Confirmar presupuesto",
    "Deseja pausar esta OS para aguardar o orçamento?": "¿Desea pausar esta orden de trabajo para esperar el presupuesto?",
    "Valor": "Valor",
    "Pausar OS": "Pausar OT",
    "Comentarios": "Comentarios",
    "Insira um comentário": "Ingrese un comentario",
    "Enviar OS": "Enviar OT",
    "Selecione uma justificativa": "Seleccione una justificación",
    "Anexos": "Adjuntos",
    "OS Socorro em Rotas": "Asistencia en ruta",
    "Confirmar Cancelamento": "Confirmar cancelación",
    "Buscar Placa": "Buscar placa",
    "Pesquisa de OS por placa": "Búsqueda de OT por placa",
    "CONTRATO_CONCESSIONARIA": "CONTRATO DE CONCESIONARIA",

    "Ordem gerada com sucesso": "Orden generada con éxito",
    "Sucesso": "Éxito",
    "Selecionar Todos": "Seleccionar todos",
    "Descrição": "Descripción",
    "Registrar Serviços": "Registrar servicios",
    "Visualizar Itens": "Ver ítems",
    "Clique no botão a direita para registrar as peças": "Haga clic en el botón de la derecha para registrar las piezas",

    "Selecionar técnico": "Seleccionar técnico",
    "KM atual/Horimetro": "Kilometraje actual/Horómetro",
    "Deseja inserir alguma imagem no atendimento": "¿Desea agregar alguna imagen al servicio?",
    "Para concluir a ação, selecione abaixo o técnico responsável": "Para completar la acción, seleccione a continuación el técnico responsable.",
    "Trabalhando": "Trabajando",
    "Matricula": "Matrícula",
    "Serviços registrado com sucesso": "Servicios registrados con éxito",
    "Função": "Función",
    "Enviar Anexos": "Enviar adjuntos",
    "Gerar Preventiva Programada": "Generar preventiva programada",
    "OS Preventiva Programada": "OT preventiva programada",
    "Finalize todas as peças e serviços para encerrar o atendimento": "Finalice todas las piezas y tareas para cerrar el atendimiento",
    "Insira um KM maior que o anterior": "Ingrese un kilometraje mayor que el anterior",
    "Insira um KM maior que o atual": "Ingrese un kilometraje mayor que el actual",
    "Inserir anexos": "Insertar adjuntos",
    "Planos Preventivos": "Planes preventivos",
    "Filtro": "Filtro",
    "ULTIMA": "ÚLTIMA",
    "Gerar Preditiva": "Generar predictiva",
    "Carregando": "Cargando",
    "OS Preventiva Programada Armazém": "OT preventiva programada almacén",
    "Gerar OS Preventiva Programada": "Generar OT preventiva programada",
    "OS Preventivas à Vencer": "OT preventivas por vencer",
    "OS de Transição": "SO de transición",

    "IMEDIATA": "INMEDIATA",
    "EMERGENCIAL": "EMERGENCIA",
    "ALTA": "ALTA",
    "MÉDIA": "MEDIA",
    "LEVE": "BAJA",

    "Registrar Tarefas": "Registrar Tareas",
    "Desbloqueia Empilhadeira": "Desbloquear Autoelevador",
    "OS Ag. Aprovação": "OT Ag. Aprobación",
    "OS Internas Veículos": "OT Internas Vehículos",
    "OS Internas Armazém": "OT Internas Depósito",
    "OS Reabertas": "OT Reabiertas",
    "Criticidade de OS Abertas": "Criticidad de las OT Abiertas",
    "Top 20 Placas com mais OS": "Top 20 Placas con más OT",
    "Qtd OS": "Cantidad OT",

    // Dashboard
    "Criticidade de OS abertas": "Criticidad de OT abiertas",
    "URGENTE": "URGENTE",
    "PREVENTIVA": "PREVENTIVA",
    "CRITICIDADES": "CRITICIDADES",
    "Bem Vindo(a)": "Bienvenido(a)",
    "Tenha acesso as principais": "Tenga acceso a las principales",
    "informações da sua mecânica!": "informaciones de su taller!",
    "Ver OS internas": "Ver OT internas",
    "OS TicketLog": "OT TicketLog",
    "OS Externas": "OT Externas",
    "OS Interna Veículos": "OT Interna Vehículos",
    "OS Interna Armazém": "OT Interna Depósito",
    "Ranking dos Mecânicos": "Ranking de los Mecánicos",
    "Tipo de OS": "Tipo de OT",
    "Atendidas nos últimos 30 dias": "Atendidas en los últimos 30 días",
    "TOP 20 Placas com mais OS": "TOP 20 Placas con más OT",
    "Últimos 30 dias": "Últimos 30 días",
    "Placas com OS Externas": "Placas con OT Externas",
    "TOP 10 Problemas mais atendidos": "TOP 10 Problemas más atendidos",
    "Nos últimos 30 dias": "En los últimos 30 días",
    "Status por Mecânico": "Estado por Mecánico",
    "Produtividade": "Productividad",

    // ModalEncerradas
    "Filtros": "Filtros",
    "NÚMERO": "NÚMERO",
    "INÍCIO": "INICIO",
    "FINAL": "FINAL",
    "SEGMENTO": "SEGMENTO",
    "PROBLEMA": "PROBLEMA",
    
    // Login
    "Acesso Rápido": "Acceso rápido",
    "ID": "ID",
    "CNPJ": "ID",
    "codigo_fornec": "code"
}